import styled from 'styled-components';
import DefaultButton from 'components/Buttons/Button';
import DefaultInput from 'components/Form/Input';
import DefaultActionButton from 'components/Buttons/ActionButton';

const actionBarHeight = '6rem';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  padding: 2rem;
  width: 45.6875rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  margin: auto auto 7rem auto;
`;

// TODO: TFR-49 split components into two or more different logical components
export const ActionBar = styled.div`
  position: fixed;
  bottom: 0;
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(0, 0, 0, 0.1),
    0rem 0.5rem 2rem rgba(0, 0, 0, 0.1);
  height: ${actionBarHeight};
  width: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Actions = styled.div`
  @media (max-width: 768px) {
    max-width: 50vw;
  }
  @media (min-width: 768px) {
    max-width: 45.6875rem;
  }
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const ActionButton = styled(DefaultActionButton)``;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  margin-left: 1rem;
`;

// TODO: TFR-45:Input make unique name or do not export
export const Input = styled(DefaultInput)`
  input {
    font-weight: 500;
    font-size: 1.1875rem;
  }
`;
